import { debounce } from '../utils';

const prepareMenu = () => {

    // Initialize submenu items with tabindex -1
    $('.nav-main .nav-sub a').each(function(){
        $(this).attr('tabindex', '-1');
    });
    
    // Mobile menu
    $('.menu-icon').click(function(e) {
        e.preventDefault();
        const $navbar = $('.navbar');
        const open = !$navbar.hasClass('menu-active');
        $navbar.toggleClass('menu-active');
        $('body').css({overflowY: open ? 'hidden' : ''})
    });

    // Sub (dropdown) menus
    $('body').on('click', function(e) {
        if ($(e.target).parents('.sub-active .nav-sub').length > 0) {
            // Click was within an active nav menu, do nothing
            return;
        }
        if (
            $(e.target).hasClass('nav-main-link')
            || $(e.target).parents('.nav-main-link').length > 0
        ) {
            if ($(e.target).attr('href') == '#') {
                e.preventDefault();
            }
            const liParent = $(e.target).parents('li').first();
            const liWasActive = $(liParent).hasClass('sub-active');
            $('.nav-main li').removeClass('sub-active');
            $('.nav-main .nav-sub a').each(function(){
                $(this).attr('tabindex', '-1');
            });
            if (
              $(liParent).find('.nav-sub').length > 0
              && !liWasActive
            ) {
                $(liParent).addClass('sub-active');
                $(liParent).find('.nav-sub a').each(function(){
                    $(this).attr('tabindex', '0');
                });
            }
        } else {
            // Click outside of an active nav menu. If we have an active sub, kill it
            $('.nav-main li').removeClass('sub-active');
            $('.nav-main .nav-sub a').each(function(){
                $(this).attr('tabindex', '-1');
            });
        }
    });

    // Search - open/close on desktop, submit
    $('body').on('click', function(e) {
        if (
            $(e.target).hasClass('icon-search')
            || $(e.target).parents('.icon-search').length > 0
        ) {
            // Click on search icon in desktop nav bar
            if ($(e.target).parents('.nav-search-icon').length > 0) {
                if ($('.nav-search-container').hasClass('search-active')) {
                    $('.nav-search-container').removeClass('search-active');
                } else {
                    $('.nav-search-container').addClass('search-active');
                    $('#search-input').focus();
                }
            }

            // Click on search icon inside search field
            if ($(e.target).parents('.nav-search-container').length > 0) {
                if ($('#search-input').val().trim() != '') {
                    $('#search-form').submit();
                } else {
                    $('.nav-search-container').removeClass('search-active');
                }
            }
        } else if ($(e.target).parents('.nav-search-container').length == 0) {
            // Clicks outside of the open search container should close it
            $('.nav-search-container').removeClass('search-active');
        }
    });
};

const makeSticky = () => {
    const minScroll = 5;
    const resizeTimeout = 300; // Intended to let transition effects settle before recalculating dimensions
    let didScroll = false;
    let lastScrollTop = 0;

    const setBodyPaddingTopToNavHeight = () => {
        $('body').css(
            'padding-top',
            $('[data-header-wrap]').outerHeight()
        );
    };

    const adjustNavVisibilityWithScroll = (scrollTop) => {
        if (scrollTop === undefined) {
            scrollTop = $(window).scrollTop();
        }
        const $headerWrap = $('[data-header-wrap]');
        if (scrollTop > lastScrollTop) {
            // Scroll Down
            if (
                scrollTop > $headerWrap.outerHeight()
                && $('.menu-active').length === 0
            ) {
                $headerWrap.css('margin-top', -1 * $headerWrap.outerHeight() + 'px');
            }
        } else {
            // Scroll Up
            if(scrollTop + $(window).height() >= $(document).height()) return;
            $headerWrap.css('margin-top', 0);
        }
    };

    setBodyPaddingTopToNavHeight();

    setInterval(() => {
        if (!didScroll) return;
        let scrollTop = $(window).scrollTop();
        if (Math.abs(lastScrollTop - scrollTop) <= minScroll) return;
        adjustNavVisibilityWithScroll(scrollTop);
        lastScrollTop = scrollTop;
        didScroll = false;
    }, 250);

    $(window).scroll(
        debounce(
            (event) => didScroll = true,
            50
        )
    );

    $(window).resize(
        debounce(
            () => {
                setBodyPaddingTopToNavHeight();
                adjustNavVisibilityWithScroll();
                // run some operations again after timeout for transition effects
                setTimeout(() => {
                    setBodyPaddingTopToNavHeight();
                }, resizeTimeout);
            },
            50
        )
    );
};

const initialize = () => {
    prepareMenu();
    makeSticky();
};

export default {
    initialize,
};

